import React from 'react'
import { Helmet } from 'react-helmet-async'

const SITE_NAME = 'Cadencya'
const DEFAULT_DESCRIPTION =
  'Toda tu música, en un solo lugar. Desde el atril de ensayo hasta el aplauso en la actuación. Gestiona plantilla, archivo, ensayos y la web pública de tu banda.'
const SITE_URL = typeof window !== 'undefined' ? window.location.origin : 'https://cadencya.com'
const DEFAULT_IMAGE = `${SITE_URL}/assets/og-whatsapp.jpg?v=icon1`
const DEFAULT_TITLE = `${SITE_NAME} — Toda tu música, en un solo lugar`
const OG_IMAGE_WIDTH = '1200'
const OG_IMAGE_HEIGHT = '1200'

function ogImageType(url) {
  return /\.jpe?g(\?|$)/i.test(url) ? 'image/jpeg' : 'image/png'
}

const SEO = ({ title, description, path = '', image, noIndex = false, jsonLd }) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE
  const desc = description || DEFAULT_DESCRIPTION
  const canonical = `${SITE_URL}${path}`
  const ogImage = image || DEFAULT_IMAGE
  const extraLd = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : []

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:secure_url" content={ogImage} />
      <meta property="og:image:type" content={ogImageType(ogImage)} />
      <meta property="og:image:width" content={OG_IMAGE_WIDTH} />
      <meta property="og:image:height" content={OG_IMAGE_HEIGHT} />
      <meta property="og:image:alt" content={SITE_NAME} />
      <meta property="og:locale" content="es_ES" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />

      <link rel="icon" type="image/png" href="/assets/icon2.png" sizes="32x32" />
      <link rel="icon" type="image/png" href="/assets/icon2.png" sizes="192x192" />
      <link rel="apple-touch-icon" href="/assets/icon2.png" />

      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {extraLd.map((data, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(data)}
        </script>
      ))}
    </Helmet>
  )
}

export default SEO
